import { ButtonBase, makeStyles } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

const useStyles = makeStyles((theme) => ({
  root: {
    width: ({ size }) => size ?? 32,
    height: ({ size }) => size ?? 32,
    '& svg': {
      width: ({ iconSize }) => iconSize ?? 16,
      height: ({ iconSize }) => iconSize ?? 16,
      fill: ({ iconColor }) => theme.colors[iconColor] ?? iconColor ?? theme.colors.brandIcon,
    },
  },
}));

const IconButtonBase = React.forwardRef((props, ref) => {
  const { size, iconSize, iconColor, className, ...otherProps } = props;

  const classes = useStyles({ size, iconSize, iconColor });

  return (
    <ButtonBase
      disableRipple
      {...otherProps}
      className={classnames(classes.root, className)}
      ref={ref}
    />
  );
});

IconButtonBase.propTypes = {
  size: PropTypes.number,
  iconSize: PropTypes.number,
  iconColor: PropTypes.string,
  className: PropTypes.string,
};

IconButtonBase.defaultProps = {
  size: undefined,
  iconSize: undefined,
  iconColor: undefined,
  className: undefined,
};

export default IconButtonBase;
